// lib/timInstance.ts
import TIM from "@tencentcloud/chat";
import TIMUploadPlugin from "tim-upload-plugin";

let tim: any;

export const initTim = (SDKAppID: number) => {
  if (!tim) {
    tim = TIM.create({ SDKAppID });
    tim.registerPlugin({ "tim-upload-plugin": TIMUploadPlugin });
    tim.setLogLevel(2);
  }
  return tim;
};
